import { useRef, useState } from "react";

const OPEN = 120;

// Swipe left (touch or mouse drag) to reveal an action behind the row.
export function SwipeRow({ children, action, testId }) {
  const [x, setX] = useState(0);
  const start = useRef(null);
  const [dragging, setDragging] = useState(false);

  const down = (e) => {
    if (e.target.closest("button, a, select, input")) return;
    start.current = { px: e.clientX, py: e.clientY, x0: x, locked: null };
  };
  const move = (e) => {
    const s = start.current;
    if (!s) return;
    const dx = e.clientX - s.px, dy = e.clientY - s.py;
    if (s.locked === null && (Math.abs(dx) > 6 || Math.abs(dy) > 6)) s.locked = Math.abs(dx) > Math.abs(dy) ? "x" : "y";
    if (s.locked !== "x") return;
    setDragging(true);
    setX(Math.max(-OPEN - 20, Math.min(0, s.x0 + dx)));
  };
  const up = () => {
    if (!start.current) return;
    start.current = null;
    setDragging(false);
    setX((v) => (v < -OPEN / 2 ? -OPEN : 0));
  };

  return (
    <div className="relative overflow-hidden rounded-2xl" data-testid={testId}>
      <div className="absolute inset-y-0 right-0 flex items-stretch" style={{ width: OPEN }}>
        {action(() => setX(0))}
      </div>
      <div
        onPointerDown={down} onPointerMove={move} onPointerUp={up} onPointerCancel={up} onPointerLeave={up}
        style={{ transform: `translateX(${x}px)`, transition: dragging ? "none" : "transform 200ms ease", touchAction: "pan-y" }}
        className="relative select-none"
      >
        {children}
      </div>
    </div>
  );
}
